<template>
  <v-flex xs12>
    <v-card>
      <v-flex xs12 pt-4 pb-2 px-4 v-if="err">
        <v-alert :value="true" type="error"> {{err}}</v-alert>
      </v-flex>
      <v-flex xs12 pt-4 pb-2 px-4 v-if="success">
        <v-alert type="success" :value="true">{{success}}</v-alert>
      </v-flex>
      <v-card-title class="pb-3 px-2 layout row wrap">
        <v-btn
          class="primary my-0 mx-3"
          type="button"
          @click="createRegister()">
          {{$lang.actions.createCashRegister}}
        </v-btn>
        <v-spacer />
        <v-autocomplete
          v-if="!isLocalAdmin"
          class="min-w max-w mx-3 pb-2"
          :label="$lang.actions.selectCompany"
          :items="mappedCompanies"
          v-model="selectedCompany"
          hide-details
        />
      </v-card-title>
      <div v-if="selectedCompany || (isLocalAdmin && allRegisters)">
        <transition name="fade">
          <v-data-table
            :items="allRegisters"
            :headers="headers"
            :loading="loading"
            :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
          >
            <v-progress-linear height="6" slot="progress" color="primary" indeterminate/>
            <template slot="items" slot-scope="props">
              <td>{{props.item.cashRegisterName}}</td>
              <td>{{props.item.username}}</td>
              <td>{{ formatDate(props.item.createdOn) }}</td>
              <td>{{ props.item.inUseFrom ? formatDate(props.item.inUseFrom) : '' }}</td>
              <td>{{props.item.status}}</td>
              <td>
                <v-btn
                  color="primary"
                  @click="editRegister(props.item.id)"
                >{{ $lang.actions.edit }}</v-btn>
              </td>
            </template>
          </v-data-table>
        </transition>
      </div>
    </v-card>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';
  import * as fetch_data from '../../assets/fetch_data';
  import {baseUrl} from '../../assets/url';

  export default {
    data() {
      return {
        err: '',
        success: '',
        selectedCompany: null,
        isLocalAdmin: false,
        companies: [],
        loading: false,
        language: this.$cookie.get('lang') || 'en',
        headers: [
          {text: this.$lang.labels.cashRegisterName, value: 'cashRegisterName', align: 'left'},
          {text: this.$lang.labels.username, value: 'username', align: 'left'},
          {text: this.$lang.labels.created, value: 'createdOn', align: 'left'},
          {text: this.$lang.labels.inUseFrom, value: 'inUseFrom', align: 'left'},
          {text: this.$lang.labels.status, value: 'status', align: 'left'},
          {text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false},
        ],
        allRegisters: [],
        showActive: true,
      };
    },
    watch: {
      selectedCompany(val) {
        this.fetchRegistersForCompany(val);
        this.$cookie.set('companyedit', val, { expires: '8h' });
      },
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    computed: {
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    methods: {
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
      fetchRegistersForCompany(companyId) {
        this.loading = true;
        this.allRegisters = [];
        this.activeRegsters = [];
        this.$http.post('cashregister', { companyId })
          .then((res) => {
            if (res.body.status === 'Success') {
              this.loading = false;
              this.allRegisters = res.body.cashRegisters;
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.loading = false;
            this.err = err.body.statusText || err.body.message;
        });
      },
      editRegister(id) {
        this.$router.push({ name: "cashRegisterEdit", params: { id: id }});
      },
      createRegister() {
        this.$router.push({name: "cashRegisterCreate"})
      },
    },
    created() {
      this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
      if (this.isLocalAdmin) {
        this.fetchRegistersForCompany();
        return;
      }
      this.$http.get('company')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.companies = res.body.companies;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      const edit = this.$cookie.get('companyedit');
      if (edit) this.selectedCompany = edit;
    },
  };
</script>



// WEBPACK FOOTER //
// CashRegister.vue?03ef51dc